// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let _;
let RivalIQ;
if (typeof window === 'undefined') {

    _ = require('lodash');
    const formatter = require('../../../public/modules/utils/chartDataFormatter.js');

    RivalIQ = {
        data: {},
        enums: require('../../../public/enums/metrics.js'),
        metrics: require('../../../public/modules/metrics.js'),
        formatter: require('../../../public/modules/formatter.js'),
        utils: {
            companyDisplay: require('../../../public/modules/utils/companyDisplay.js'),
            formatChartData: formatter.formatChartData,
            keywords: require('../../../public/modules/utils/keywords.js'),
            metric: require('../../../public/modules/utils/metric.js'),
            rollupFormattedChartData: formatter.rollupFormattedChartData
        }
    };

} else {
    _ = window._;
    RivalIQ = window.RivalIQ;
    RivalIQ.module('data', function () {});
}

(function () {
    'use strict';

    function CompareData(options) {
        const me = this;
        me.companies = [];
        me.concepts = {};
        me.iconUrl = {};
        me.channels = {};
        me.companiesById = {};
        me.metricsById = {};
        _.each(RivalIQ.metrics.descriptions, function (metric) {
            me.metricsById[metric.id] = metric;
        });
        _.extend(me, options);

        this.setupData();

        for (const prop in CompareData.sources) {
            if (CompareData.sources.hasOwnProperty(prop)) {
                this.channels[CompareData.sources[prop]] = {};
            }
        }
    }

    // CompareData wants metrics to be a name:id mapping
    CompareData.metrics = RivalIQ.metrics.id;

    CompareData.dataType = RivalIQ.metrics.dataType;
    CompareData.sources = RivalIQ.metrics.source;
    CompareData.metricType = RivalIQ.metrics.metricType;
    CompareData.category = RivalIQ.metrics.category;
    CompareData.iconUrls = RivalIQ.metrics.iconUrls;

    CompareData.formats = {};
    CompareData.formats.INTEGER = ',.0f';
    CompareData.formats.NUMERIC2 = ',.2f';
    CompareData.formats.PERCENT = '+,.2%';
    CompareData.formats.ABSOLUTE_PERCENT = ',.2%';

    CompareData.strings = RivalIQ.enums.strings;

    CompareData.sourceDetails = RivalIQ.enums.sourceDetails;

    CompareData.channels = {};
    _.each(_.keys(CompareData.sources), function (sourceName) {
        CompareData.channels[sourceName] = CompareData.sourceDetails[CompareData.sources[sourceName]].channel;
    });

    CompareData.metricColumnHelpers = {};

    /**
     * Gets a source from a channel.
     * @param channel The name of the channel.
     * @param [sources] An optional list of allowed sources.
     */
    CompareData.getSource = function (channel, sources) {

        return _.find(sources || CompareData.sources, function (source) {

            const sourceDetails = CompareData.sourceDetails[source];
            return (sourceDetails.channel.toLowerCase() === (channel || '').toLowerCase());
        });
    };

    /**
     * Gets metrics by category and/or source
     * @param compareData
     * @param category          - a single category type to select
     * @param redactedSources   - optional list of sources to reject
     * @returns {*|Array}
     */
    CompareData.getMetrics = function (compareData, category, redactedSources) {

        return _.reject(CompareData.metrics, function (metric) {

            const metricSource = compareData.getMetricSource(metric);
            const metricCategory = compareData.getMetricCategory(metric);

            const isPrivateData = CompareData.sourceDetails[metricSource].privateData;
            const notShownInUi = compareData.getMetricDontShowInUi(metric);
            const rejectCategory = (_.isFinite(category) ? category !== metricCategory : false);
            let rejectSource = false;

            if (redactedSources) {
                if (_.isFinite(redactedSources)) {
                    redactedSources = [redactedSources];
                }

                if (_.isArray(redactedSources)) {
                    rejectSource = _.includes(redactedSources, metricSource);
                }
            }

            return isPrivateData || notShownInUi || rejectSource || rejectCategory;
        });

    };


    (function () {

        // gets the length of the value
        function getValueLength(datum) {
            const value = datum.value;

            if (value === CompareData.strings.NOT_ON_CHANNEL) {
                return '--';
            } else if (value !== CompareData.strings.EMPTY_TEXT && value) {
                return value.length;
            } else {
                return 0;
            }
        }

        // gets the meta description quality of the value
        function getValueMetaDescriptionQuality(datum) {
            let value;
            const length = getValueLength(datum);

            if (length > 160) {
                value = 'Long';
            } else if (length < 90) {
                value = 'Short';
            } else {
                value = 'Good';
            }

            return value;
        }

        // sorts by length of value
        function lengthSort(order, a, b) {
            let value;
            const aLength = getValueLength(a);
            const bLength = getValueLength(b);

            if (isNaN(aLength)) {
                value = -1;
            } else if (isNaN(bLength)) {
                value = 1;
            } else {
                value = aLength - bLength;
            }

            return order * value;
        }

        // sorts value by meta description quality (alphabetically)
        function metaDescriptionQualitySort(order, a, b) {
            const aQuality = getValueMetaDescriptionQuality(a);
            const bQuality = getValueMetaDescriptionQuality(b);
            return order * aQuality.localeCompare(bQuality);
        }

        // gets the string length of a string data value
        CompareData.metricColumnHelpers.length = {
            name: 'Length',
            sortKey: 'length',
            className: 'x-length',
            cellClassName: 'x-length',
            value: getValueLength,
            sort: lengthSort
        };

        // gets the string length quality of a meta description data value
        CompareData.metricColumnHelpers.metaDescriptionLengthQuality = {
            name: 'Length is',
            sortKey: 'length-quality',
            className: 'x-length-quality',
            cellClassName: 'x-length-quality',
            value: getValueMetaDescriptionQuality,
            sort: metaDescriptionQualitySort
        };

        // populate table columns from configuration
        _.each(RivalIQ.metrics.descriptions, function (description) {

            // if there are no columns keep on chugging
            if (!description.columns) {

                return;
            }

            // we have columns, let's translate them into helpers if we can
            description.columns = _.map(description.columns, function (column) {

                const helper = CompareData.metricColumnHelpers[column];
                const result = helper || column;
                return result;
            });
        });

    }());

    // BUGBUG ideally would be shared with the stuff in dataServicesHelpers...
    CompareData.calculateDeltaRelative = function (value1, value2) {

        if (!_.isFinite(value1) || !_.isFinite(value2)) {
            return null;
        }

        const deltaAbsolute = value2 - value1;

        if (value1 !== 0) {
            return deltaAbsolute / value1;
        } else {
            return (deltaAbsolute !== 0 ? null : 0);
        }
    };

    CompareData.prototype.createConcept = function (concept, columns, defaultSort, sorter) {
        this.concepts[concept] = {};
        this.concepts[concept].columns = columns;
        this.concepts[concept].defaultSort = defaultSort;
        this.concepts[concept].sorter = sorter;
    };

    CompareData.prototype.getSourceDetails = function (source) {
        return CompareData.sourceDetails[source];
    };

    CompareData.prototype.getMetricDataType = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else {
            return this.concepts[concept].columns[1].dataType;
        }
    };

    CompareData.prototype.getMetricName = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else {
            return this.concepts[concept].columns[1].name;
        }
    };

    CompareData.prototype.getCamelCaseMetricName = function (concept) {
        const me = this;
        const name = me.getMetricName(concept);

        return RivalIQ.utils.metric.camelCaseMetricName(name);
    };

    CompareData.prototype.getMetricType = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else {
            return this.concepts[concept].columns[1].metricType;
        }
    };

    CompareData.prototype.getMetricDescription = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else if (typeof this.concepts[concept].columns[1].description === 'undefined') {
            return '';
        } else {
            return this.concepts[concept].columns[1].description;
        }
    };

    CompareData.prototype.getMetricIconUrl = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else if (typeof this.concepts[concept].columns[1].iconUrl === 'undefined') {
            return '';
        } else {
            return this.concepts[concept].columns[1].iconUrl;
        }
    };

    CompareData.prototype.getMetricFontIcon = function (concept) {

        if (typeof concept === 'undefined' || concept === null) {
            return null;
        }

        const fontIcon = CompareData.sourceDetails[this.concepts[concept].columns[1].source].fontIcon;

        if (typeof fontIcon === 'undefined') {
            return '';
        }

        return fontIcon;
    };

    CompareData.prototype.getMetricSource = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else if (typeof this.concepts[concept].columns[1].source === 'undefined') {
            return '';
        } else {
            return this.concepts[concept].columns[1].source;
        }
    };

    CompareData.prototype.getMetricCategory = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else if (typeof this.concepts[concept].columns[1].category === 'undefined') {
            return '';
        } else {
            return this.concepts[concept].columns[1].category;
        }
    };

    CompareData.prototype.getMetricSourceName = function (concept) {
        const metricSource = this.getMetricSource(concept);
        if (metricSource === null) {
            return null;
        } else {
            return (CompareData.sourceDetails[metricSource] || {}).name || '';
        }
    };

    CompareData.prototype.getMetricDontShowInUi = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else if (typeof this.concepts[concept].columns[1].dontShowInUi === 'undefined') {
            return '';
        } else {
            return this.concepts[concept].columns[1].dontShowInUi;
        }
    };

    CompareData.prototype.getMetricApiOnly = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else if (typeof this.concepts[concept].columns[1].apiOnly === 'undefined') {
            return '';
        } else {
            return this.concepts[concept].columns[1].apiOnly;
        }
    };

    CompareData.prototype.useSourceNameForSubmetricLegend = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else {
            return this.concepts[concept].columns[1].useSourceNameForSubmetricLegend;
        }
    };

    CompareData.prototype.getFormat = function (concept, timeAnalysisMode) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else if (timeAnalysisMode === RivalIQ.enums.timeAnalysisMode.DELTA_RELATIVE) {
            return CompareData.formats.PERCENT;
        } else if (typeof this.concepts[concept].columns[1].format !== 'undefined') {
            return this.concepts[concept].columns[1].format;
        } else if (this.concepts[concept].columns[1].dataType === CompareData.dataType.ABSOLUTE_PERCENT) {
            return RivalIQ.formatter.absolutePercent;
        } else if (this.concepts[concept].columns[1].dataType === CompareData.dataType.INTEGER) {
            return CompareData.formats.INTEGER;
        } else {
            return CompareData.formats.NUMERIC2;
        }
    };

    CompareData.prototype.getMetricAbbreviatedName = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else if (typeof this.concepts[concept].columns[1].abbreviatedName === 'undefined') {
            return this.getMetricName(concept);
        } else {
            return this.concepts[concept].columns[1].abbreviatedName;
        }
    };

    CompareData.prototype.getMetricShortName = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else if (typeof this.concepts[concept].columns[1].shortName === 'undefined') {
            return this.getMetricName(concept);
        } else {
            return this.concepts[concept].columns[1].shortName;
        }
    };

    // get metric export name for concept
    CompareData.prototype.getMetricExportName = function (concept, useAbbreviated) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else if (typeof this.concepts[concept].columns[1].exportName === 'undefined') {
            return useAbbreviated ? this.getMetricAbbreviatedName(concept) : this.getMetricName(concept);
        } else {
            return this.concepts[concept].columns[1].exportName;
        }
    };

    // get metric abbreviated export name for concept
    CompareData.prototype.getMetricAbbreviatedExportName = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else if (typeof this.concepts[concept].columns[1].abbreviatedExportName === 'undefined') {
            return this.getMetricExportName(concept, true);
        } else {
            return this.concepts[concept].columns[1].abbreviatedExportName;
        }
    };

    // get metric API name for concept
    function generateApiName(descriptor) {
        let channel = CompareData.sourceDetails[descriptor.source].name.toLowerCase();
        let name = descriptor.name.toLowerCase();

        // Canonicalize the channel name.
        if (channel === 'cross-channel') {
            channel = 'cross channel';
        }

        // Likewise any channel embedded in the name.
        name = name.replace('you tube', 'youtube');

        // Unnecessary in the API name.
        name = name.replace(' (approx.)', '');

        // Ensure the channel name is at the beginning.
        if (!name.startsWith(`${channel} `)) {
            name = `${channel} ${name.replace(`${channel} `, '')}`;
        }

        // Ensure all words are capitalized.
        name = _.map(_.words(name), function (word) {
            return _.upperFirst(word);
        }).join(' ');

        return name;
    }

    CompareData.prototype.getMetricApiName = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        }

        const descriptor = this.concepts[concept].columns[1];

        if (typeof descriptor.apiName === 'undefined') {
            descriptor.apiName = generateApiName(descriptor);
        }

        return descriptor.apiName;
    };

    // get camel-cased metric API name for concept
    CompareData.prototype.getCamelCaseMetricApiName = function (concept) {
        const me = this;
        const name = me.getMetricApiName(concept);

        return RivalIQ.utils.metric.camelCaseMetricName(name);
    };

    // returns table columns if they exist for this concept
    CompareData.prototype.getMetricColumns = function (concept) {
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else {
            return this.concepts[concept].columns[1].columns;
        }
    };

    CompareData.prototype.getMetricSubmetrics = function (concept) {
        const me = this;
        if (typeof concept === 'undefined' || concept === null) {
            return null;
        } else {
            return me.concepts[concept].columns[1].submetrics;
        }
    };

    CompareData.prototype.getMetricSubmetricsPalette = function (concept) {
        const me = this;

        // we make a map to count occurrences of submetrics by source (channel)
        // this is important because we need to roll the colors in the palette
        // per channel (e.g., tweets and retweets should get two different colors
        // from same palette, twitter followers and facebook likes should get two
        // different colors from two different palettes)
        const sources = {};
        const submetrics = me.getMetricSubmetrics(concept) || [];

        return _.map(submetrics, function (metric) {
            const source = me.getMetricSource(metric);
            const details = me.getSourceDetails(source);
            const palette = details.palette || [];

            // create, or increment the metric source count
            if (!_.has(sources, source)) {
                sources[source] = 0;
            } else {
                sources[source] += 1;
            }

            // this is where we do the rolling of the palette color
            // based on the number of times we've seen this source
            // in sub metrics (described more in depth above)
            return palette[sources[source] % palette.length];
        });
    };

    CompareData.prototype.setupData = function () {
        const me = this;

        _.each(RivalIQ.metrics.descriptions, _.bind(me.addMetric, me));
    };

    CompareData.prototype.addMetric = function (description) {
        const me = this;
        let sort;
        let sortFn;
        const companyColumn = {
            name: 'Company Name',
            type: 'string'
        };
        const metricColumn = _.extend({}, description);

        // compareData expects submetrics to be ids instead of keys
        if (metricColumn.submetrics) {
            metricColumn.submetrics = _.map(metricColumn.submetrics, function (submetric) {
                return CompareData.metrics[submetric];
            });
        }

        // sort by company name if the value is a string, else sort by metric
        if (description.dataType === CompareData.dataType.STRING) {
            sort = [0, 'asc'];
            sortFn = me.sorterCompanyName;
        } else {
            sort = [1, 'desc'];
            sortFn = me.sorterNumericDesc;
        }

        // create the concept
        me.createConcept(description.id, [companyColumn, metricColumn], sort, sortFn);
    };

    CompareData.prototype.addIconUrl = function (companyId, iconUrl) {
        this.iconUrl[companyId] = iconUrl;
    };

    CompareData.prototype.getIconUrl = function (companyId) {
        if (typeof this.iconUrl[companyId] !== 'undefined') {
            return this.iconUrl[companyId];
        } else {
            return '';
        }
    };

    CompareData.prototype.getFontIcon = function (companyId) {
        if (typeof this.fontIcon[companyId] !== 'undefined') {
            return this.fontIcon[companyId];
        } else {
            return '';
        }
    };

    /**
     * The metric value types.
     */
    CompareData.valueType = RivalIQ.enums.valueType;

    CompareData.singularValues = [
        CompareData.valueType.CURRENT,
        CompareData.valueType.PREVIOUS,
        CompareData.valueType.DELTA,
        CompareData.valueType.DELTA_REL,
        CompareData.valueType.PRESENCE
    ];

    function hasChannel(company, metric) {
        return Boolean(_.get(company, ['periodSummary', metric.rollupSource, 0, 'presence']));
    }

    function getDefaultValue(metric, value, company) {
        let val = null;

        if (_.includes(CompareData.singularValues, value)) {
            if (value === CompareData.valueType.PRESENCE) {
                if (hasChannel(company, metric)) {
                    val = CompareData.strings.EMPTY_TEXT;
                } else {
                    val = CompareData.strings.NOT_ON_CHANNEL;
                }
            }

            return {
                companyId: company.id,
                companyName: company.name,
                value: val
            };
        }

        return val;
    }

    CompareData.prototype.getValue = function (concept, type, mode, companyId, presenceId) {
        const me = this;

        if (_.isUndefined(companyId)) { // Get values for all companies
            return _.reduce(me.companies, function (memo, company) {
                memo[company.id] = me.getValue(concept, type, mode, company.id);
                return memo;
            }, {});
        }
        let metric = me.metricsById[concept];
        if (!metric) {
            metric = me.metricsById[concept] = _.find(RivalIQ.metrics.descriptions, {
                id: concept
            });
        }
        const company = me.companiesById[companyId];

        const presences = company.periodSummary[metric.rollupSource] || [];

        if (_.isUndefined(presenceId)) {
            // Primary presence is the first in the rollup array
            presenceId = _.get(presences[0], 'presence.id');
        }

        let presence = _.find(presences, function (presence) {
            return (presenceId === _.get(presence, 'presence.id'));
        });

        // String metrics are stored in the presence
        if (metric.dataType === CompareData.dataType.STRING && type === CompareData.valueType.CURRENT) {
            type = CompareData.valueType.PRESENCE;
        }

        if (presence) {
            if (mode === 'normalized' && presence.normalized) {
                presence = presence.normalized;
            }

            const values = presence[type];

            if (_.isArray(values)) {
                return _.map(values, function (periodValues) {
                    return _.get(periodValues, metric.propDaily);
                });
            }

            let value;
            value = _.get(values, metric.propSummary);

            // TODO this really does not belong here
            if (_.exists(value) && metric.id === CompareData.metrics.YOUTUBE_KEYWORDS) {
                value = RivalIQ.utils.keywords.formatQuotedKeywords(value);
            } else if (_.exists(value) && metric.id === CompareData.metrics.WEB_HOMEPAGE_META_KEYWORDS) {
                value = me.getMetaKeywords(value);
            }

            if (_.exists(value) && value !== '') {
                return {
                    companyId: company.id,
                    companyName: company.name,
                    value: value
                };
            }
        }

        return getDefaultValue(metric, type, company);
    };

    CompareData.prototype.getValueData = function (concept, value, options) {
        const me = this;
        options = options || {};
        let palette;
        let submetrics;

        if (options.shouldIncludeSubmetrics) {
            submetrics = me.getMetricSubmetrics(concept);
            palette = me.getMetricSubmetricsPalette(concept);
        }

        const values = _.map(me.companies, function (company) {
            const datum = me.getValue(concept, value, options.mode, company.id, options.presenceId);

            if (datum && submetrics && submetrics.length) {
                datum.submetrics = _.map(submetrics, function (metric, index) {
                    const submetric = me.getValue(metric, value, options.mode, company.id, options.presenceId);

                    if (submetric) {
                        // the submetric index corresponds to the palette index
                        submetric.class = palette[index];
                    }

                    return _.extend({
                        source: me.getMetricSource(submetrics[index])
                    }, submetric);
                });
            }

            return datum;
        });

        return values;
    };

    CompareData.prototype.getCurrData = function (concept) {
        return this.getValueData(concept, CompareData.valueType.CURRENT, {
            shouldIncludeSubmetrics: true
        });
    };

    CompareData.prototype.getPrevData = function (concept) {
        return this.getValueData(concept, CompareData.valueType.PREVIOUS);
    };

    CompareData.prototype.getDeltaData = function (concept) {
        return this.getValueData(concept, CompareData.valueType.DELTA, {
            shouldIncludeSubmetrics: true
        });
    };

    function getTimeSpanSources(dates, timeAnalysisMode, options) {
        let source = 'dailyValues';

        if (options.serverRollup) {
            const modes = RivalIQ.enums.timeAnalysisMode;
            if (timeAnalysisMode === modes.WEEKLY_VALUES) {
                source = 'weeklyValues';
            } else if (timeAnalysisMode === modes.MONTHLY_VALUES) {
                source = 'monthlyValues';
            }
        }

        if (!dates) {
            return [{
                source: source
            }];
        }

        const sources = [{
            source: source,
            mainPeriodStart: dates.mainPeriodStart,
            mainPeriodEnd: dates.mainPeriodEnd
        }];

        if (options.includeComparePeriod) {
            sources.unshift({
                source: [source, 'Period1'].join(''),
                mainPeriodStart: dates.comparePeriodStart,
                mainPeriodEnd: dates.comparePeriodEnd
            });
        }

        return sources;
    }

    // TODO Caching this could really speed up some metrics
    // processing
    function rollupDailyValues(source, dailyValues, timeAnalysisMode, concept, compareData, companyId, options) {

        let data = RivalIQ.utils.formatChartData(source.mainPeriodStart,
            source.mainPeriodEnd, dailyValues);

        data = RivalIQ.utils.rollupFormattedChartData(data,
            timeAnalysisMode, concept, compareData, source, companyId, options.activeSources);

        return _.map(data.values, 'total');
    }

    /**
     * Gets time span data with optional dates, time analysis mode.
     * @param concept
     * @param [dates]
     * @param [timeAnalysisMode]
     */
    CompareData.prototype.getTimeSpanData = function (concept, dates, timeAnalysisMode, companyId, options) {
        const me = this;
        options = options || {};

        const ids = (_.exists(companyId) ? [companyId] : _.map(me.companies, 'id'));

        const sources = getTimeSpanSources(dates, timeAnalysisMode, options);

        return _.map(ids, function (id) {

            const values = Array.prototype.concat.apply([], _.map(sources, function (source) {
                const vals = me.getValue(concept, source.source, options.mode, id, options.presenceId) || [];

                if (!options.serverRollup && source.mainPeriodStart) {
                    return rollupDailyValues(source, vals, timeAnalysisMode, concept, me, id, options);
                }

                return vals;
            }));

            return {
                companyId: id,
                values: values
            };
        });
    };

    const getValueIfPresent = function (obj, param) {
        if (obj !== null) {
            return obj[param];
        } else {
            return null;
        }
    };

    CompareData.prototype.getCompleteDataForMetricByCompanyId = function (concept, companyId, otherCompaniesToInclude) {

        const me = this;
        const retObj = {};
        let allCompaniesToInclude = null;

        if (otherCompaniesToInclude) {
            allCompaniesToInclude = otherCompaniesToInclude.slice();
            allCompaniesToInclude.push(companyId);
        }

        // metadata
        retObj.metric = concept;
        retObj.metricName = this.getMetricName(concept);
        retObj.metricAbbreviatedName = this.getMetricAbbreviatedName(concept);
        retObj.description = this.getMetricDescription(concept);
        retObj.iconUrl = this.getMetricIconUrl(concept);
        retObj.fontIcon = this.getMetricFontIcon(concept);
        retObj.metricType = this.getMetricType(concept);
        retObj.metricSource = this.getMetricSource(concept);
        retObj.metricSourceName = this.getSourceDetails(retObj.metricSource).name;

        if (!me.hasCompleteDataForPeriod(concept, companyId)) {

            retObj.focusCompanyHasMetric = false;
            retObj.currentVal = null;
            retObj.deltaAbsVal = null;
            retObj.deltaRelVal = null;
            retObj.sortedCurr = this.getSortedMetricByTimePeriod(concept, 'curr', otherCompaniesToInclude);
            retObj.sortedAbsVal = this.getSortedMetricByTimePeriod(concept, 'deltaAbs', otherCompaniesToInclude);
            retObj.sortedRelVal = this.getSortedMetricByTimePeriod(concept, 'deltaRel', otherCompaniesToInclude);
            retObj.sortedRelVal.forEach(function (item) {
                item.absVal = me.getDeltaDataForCompanyId(concept, item.companyId);
            });

        } else {

            retObj.focusCompanyHasMetric = true;
            retObj.currentVal = this.getCurrDataForCompanyId(concept, companyId).value;
            retObj.sortedCurr = this.getTopNWithMeForMetric(concept, 'curr', 0, companyId, allCompaniesToInclude);
            retObj.myRankCurr = _.find(retObj.sortedCurr, function (item) {
                return item.companyId === companyId;
            });

            retObj.deltaAbsVal = getValueIfPresent(this.getDeltaDataForCompanyId(concept, companyId), 'value');
            retObj.deltaRelVal = getValueIfPresent(this.getDeltaRelDataForCompanyId(concept, companyId), 'value');

            // only bother getting the delta data if our delta data exists
            if (retObj.deltaAbsVal !== null) {

                retObj.sortedAbsVal = this.getTopNWithMeForMetric(concept, 'deltaAbs', 0, companyId, allCompaniesToInclude);
                retObj.myRankAbs = _.find(retObj.sortedAbsVal, function (item) {
                    return item.companyId === companyId;
                });

                retObj.sortedRelVal = this.getTopNWithMeForMetric(concept, 'deltaRel', 0, companyId, allCompaniesToInclude);
                retObj.sortedRelVal.forEach(function (item) {
                    item.absVal = me.getDeltaDataForCompanyId(concept, item.companyId);
                });

                // NOTE if `deltaRelVal` is `null` then it has been redacted,
                // which is different from does not exist, so we need to fake
                // the ranking by putting the company at the end
                // TODO: rankings - remove with legacy rankings
                if (retObj.deltaRelVal === null) {
                    retObj.myRankRel = _.defaults({
                        rank: retObj.sortedRelVal.length + 1,
                        totalItems: retObj.sortedRelVal.length + 1
                    }, _.pick(me.getDeltaDataForCompanyId(concept, companyId), 'companyId', 'companyName'));
                } else {
                    retObj.myRankRel = _.find(retObj.sortedRelVal, function (item) {
                        return item.companyId === companyId;
                    });
                }
            }

        }

        retObj.meanCurr = me.computeMean(_.map(retObj.sortedCurr, 'value'));
        retObj.medianCurr = me.computeMedian(_.map(retObj.sortedCurr, 'value'));
        retObj.meanAbsVal = me.computeMean(_.map(retObj.sortedAbsVal, 'value'));
        retObj.medianAbsVal = me.computeMedian(_.map(retObj.sortedAbsVal, 'value'));
        retObj.meanRelVal = me.computeMean(_.map(retObj.sortedRelVal, 'value'));
        retObj.medianRelVal = me.computeMedian(_.map(retObj.sortedRelVal, 'value'));

        if (me.hasDailyValues(concept, companyId)) {
            const dv = me.getDailyValuesByCompanyId(concept, companyId);
            const d = [];
            let count = 0;
            dv.forEach(function (item) {
                d.push({
                    x: count++,
                    y: item
                });
            });
            retObj.dailyValues = d;
        } else {
            retObj.dailyValues = null;
        }

        return retObj;
    };

    CompareData.prototype.getDataForTimePeriodType = function (concept, timePeriod, companyId, otherCompaniesToInclude) {
        const me = this;

        let data;
        if (!me.hasCompleteDataForPeriod(concept, companyId)) {
            data = me.getSortedMetricByTimePeriod(concept, timePeriod, otherCompaniesToInclude);
        } else {
            data = me.getTopNWithMeForMetric(concept, timePeriod, 0, companyId, [companyId].concat(otherCompaniesToInclude));
        }

        return data;
    };

    CompareData.prototype.getCompanyRankCurr = function (concept, companyId, otherCompaniesToInclude) {
        const me = this;

        if (me.hasCompleteDataForPeriod(concept, companyId)) {
            const sortedCurr = me.getTopNWithMeForMetric(concept, 'curr', 0, companyId, [companyId].concat(otherCompaniesToInclude));
            return _.find(sortedCurr, function (item) {
                return item.companyId === companyId;
            });
        }

        return null;
    };

    CompareData.prototype.computeMean = function (arr) {
        let retVal = null;
        if (arr) {
            const arrValid = _.without(arr, null);
            if (arrValid.length > 0) {
                let sum = 0;
                for (let i = 0; i < arrValid.length; i++) {
                    sum += arrValid[i];
                }
                retVal = sum / arrValid.length;
            }
        }
        return retVal;
    };

    CompareData.prototype.computeMedian = function (arr) {
        let retVal = null;
        if (arr) {
            const arrValid = _.without(arr, null);
            if (arrValid.length > 1) {
                const middleIndex = Math.floor(arrValid.length / 2);
                if (arrValid.length % 2 === 0) {
                    retVal = (arrValid[middleIndex - 1] + arrValid[middleIndex]) / 2;
                } else {
                    retVal = arrValid[middleIndex];
                }
            } else if (arrValid.length === 1) {
                retVal = arrValid[0];
            }
        }
        return retVal;
    };

    (function () {
        // Select and score metrics with the given conditions
        CompareData.prototype.selectMetrics = function (conditions) {
            const me = this;

            const metrics = _.filter(RivalIQ.metrics.descriptions, conditions);
            return _.map(metrics, function (metricDesc) {
                return _.extend(me.data[metricDesc.id], {
                    metricId: metricDesc.id,
                    timePeriod: me.timePeriod
                });
            });
        };
    }());

    CompareData.prototype.getDailyValuesByCompanyId = function (concept, companyId, mode, presenceId) {
        const me = this;
        return me.getValue(concept, CompareData.valueType.DAILY, mode, companyId, presenceId) || [];
    };

    CompareData.prototype.getCurrDataForCompanyId = function (concept, companyId, mode, presenceId) {
        const me = this;
        return me.getValue(concept, CompareData.valueType.CURRENT, mode, companyId, presenceId);
    };

    CompareData.prototype.getPrevDataForCompanyId = function (concept, companyId, mode, presenceId) {
        const me = this;
        return me.getValue(concept, CompareData.valueType.PREVIOUS, mode, companyId, presenceId);
    };

    CompareData.prototype.getDeltaDataForCompanyId = function (concept, companyId, mode, presenceId) {
        const me = this;
        return me.getValue(concept, CompareData.valueType.DELTA, mode, companyId, presenceId);
    };

    CompareData.prototype.getDeltaRelData = function (concept) {
        const me = this;
        return _.values(me.getValue(concept, CompareData.valueType.DELTA_REL));
    };

    CompareData.prototype.getDeltaRelDataForCompanyId = function (concept, companyId, mode) {
        const me = this;
        return me.getValue(concept, CompareData.valueType.DELTA_REL, mode, companyId);
    };

    CompareData.prototype.getSortedMetricByTimePeriod = function (metric, timePeriod, companiesToInclude, includeNulls) {

        let returnSet = [];

        if (_.isUndefined(includeNulls)) {
            includeNulls = false;
        }

        switch (timePeriod) {
            case 'curr':
                returnSet = this.getCurrData(metric).sort(this.metricSorter);
                break;
            case 'prev':
                returnSet = this.getPrevData(metric).sort(this.metricSorter);
                break;
            case 'deltaAbs':
                returnSet = this.getDeltaData(metric).sort(this.metricSorter);
                break;
            case 'deltaRel':
                returnSet = this.getDeltaRelData(metric).sort(this.metricSorter);
                break;
            default:
                throw new Error(`unknown time period ${timePeriod}`);

        }
        if (typeof companiesToInclude !== 'undefined' && companiesToInclude !== null) {
            const hash = {};
            companiesToInclude.forEach(function (item) {
                hash[item] = true;
            });

            returnSet = _.filter(returnSet, function (item) {
                return hash[item.companyId];
            });
        }

        if (!includeNulls) {
            returnSet = _.filter(returnSet, function (item) {
                return item && item.value !== null;
            });
        }

        let rank = 1;
        const count = returnSet.length;
        returnSet.forEach(function (item) {
            item.rank = rank++;
            item.totalItems = count;
        });

        return returnSet;
    };


    CompareData.prototype.getStatsForMetric = function (metric, timePeriod) {

        const average = function (a) {
            const r = {
                mean: 0,
                variance: 0,
                deviation: 0
            };
            const t = a.length;
            let m;
            let s = 0;
            let l;

            for (m, s = 0, l = t; l--; s += a[l]) { /* empty */ }

            for (m = r.mean = s / t, l = t, s = 0; l--; s += Math.pow(a[l] - m, 2)) { /* empty */ }

            r.deviation = Math.sqrt(r.variance = s / t);

            return r;
        };

        const returnSet = this.getSortedMetricByTimePeriod(metric, timePeriod);

        return average(_.map(returnSet, 'value'));
    };


    CompareData.prototype.getTopNForMetric = function (metric, timePeriod, n, includeNulls) {

        let returnSet = this.getSortedMetricByTimePeriod(metric, timePeriod, null, includeNulls);
        if (n > 0) {
            returnSet = returnSet.slice(0, n);
        }
        return returnSet;
    };

    CompareData.prototype.getTopNWithMeForMetric = function (metric, timePeriod, n, myCompany, companiesToInclude) {

        let returnSet = this.getSortedMetricByTimePeriod(metric, timePeriod, companiesToInclude);
        const originalSet = _.compact(returnSet);
        if (n > 0) {
            returnSet = returnSet.slice(0, n);
        }
        let imInThere = false;
        returnSet.forEach(function (item) {
            if (item.companyId === myCompany) {
                imInThere = true;
            }
        });

        if (!imInThere) {
            const myRecord = _.find(originalSet, function (item) {
                return item.companyId === myCompany;
            });
            if (typeof myRecord !== 'undefined') {
                returnSet.push(myRecord);
            }

        }
        return returnSet;
    };

    CompareData.prototype.metricSorter = function (a, b) {
        let retval = 1;
        if (a.value !== null && b.value !== null) {
            retval = ((a.value > b.value) ? -1 : 1);
        } else if (a.value !== null && b.value === null) {
            retval = -1;
        } else if (a.value === null && b.value !== null) {
            retval = 1;
        }
        return retval;
    };

    CompareData.prototype.companyHasMetric = function (concept, companyId) {
        const me = this;
        const currData = me.getCurrDataForCompanyId(concept, companyId);
        return currData && currData.value !== null;
    };

    CompareData.prototype.setHasChannel = function (channel, companyId) {
        this.channels[channel][companyId] = true;
    };

    /**
     * Determines if the company has the channel.
     * @param channel The channel.
     * @param companyId The company to check.
     * @returns {Boolean} A boolean indicating if the company has the channel.
     */
    CompareData.prototype.hasChannelBySource = function (channel, companyId) {

        const me = this;
        const sourceDetails = CompareData.sourceDetails[channel];

        if (sourceDetails && sourceDetails.subSources) {

            return _.some(sourceDetails.subSources, function (subSource) {

                return me.hasChannelBySource(subSource, companyId);
            });
        }

        return (me.channels[channel][companyId] === true);
    };

    /**
     * Determines if the company has the channel corresponding to the concept.
     * @param concept The metric.
     * @param companyId The company to check presences.
     * @returns {Boolean} A boolean indicating if the company has the channels corresponding to the concept.
     */
    CompareData.prototype.hasChannelByConcept = function (concept, companyId) {

        const me = this;
        const source = me.getMetricSource(concept);
        return me.hasChannelBySource(source, companyId);
    };

    CompareData.prototype.hasCompleteDataForPeriod = function (concept, companyId) {
        const me = this;

        const hasMetric = me.companyHasMetric(concept, companyId);
        return (hasMetric && !_.isNull(me.getCurrDataForCompanyId(concept, companyId).value));
    };

    CompareData.prototype.hasDailyValues = function (concept, companyId) {
        const me = this;

        const hasMetric = me.companyHasMetric(concept, companyId);
        return hasMetric && me.getDailyValuesByCompanyId(concept, companyId).length;
    };

    // merge metric b into metric a (destination, source)
    function mergeMetrics(destination, source) {
        if (!_.exists(destination)) {
            return source;
        }

        if (!_.exists(source)) {
            return destination;
        }

        const result = _.clone(destination);
        _.each(source, function (v, k) {
            if (!_.exists(v)) {
                return;
            }

            const destinationSubmetrics = _.get(destination, [k, 'submetrics']);
            const sourceSubmetrics = _.get(source, [k, 'submetrics']);
            const submetrics = mergeMetrics(destinationSubmetrics, sourceSubmetrics);
            let existingValue = result[k];

            // sometimes values are simple values, sometimes values are {value: number},
            // expand as necessary to merge sensibly
            if (_.exists(v) && !_.isPlainObject(v) && _.isPlainObject(existingValue)) {
                v = {
                    value: v
                };
            }

            if (!_.isPlainObject(existingValue) && _.isPlainObject(v)) {
                existingValue = {
                    value: existingValue
                };
            }

            // don't clobber values with nulls... but pick up any additional submetrics
            result[k] = (_.exists(v) && _.get(v, 'value') !== null ? v : existingValue);
            if (result[k] && _.exists(submetrics)) {
                if (!_.isPlainObject(result[k])) {
                    result[k] = {
                        value: result[k]
                    };
                }
                result[k].submetrics = submetrics;
            }
        });

        return result;
    }

    // merge presence b into presence a (destination, source)
    function mergePresences(destination, source) {
        const staticAttrs = ['hasPrivateData', 'presence', 'dates', 'normalized'];

        source.dates = _.merge(destination.dates, source.dates);

        _.each(_.omit(source, staticAttrs), function (v, k) {
            if (_.isArray(v)) {
                destination[k] = _.map(v, function (intervalValue, idx) {
                    return mergeMetrics(_.get(destination, [k, idx]), intervalValue);
                });
            } else {
                destination[k] = mergeMetrics(destination[k], v);
            }
        });

        // normalized is a little sub list of metrics, merge these separately so mergeMetrics doesn't get confused.
        _.each(source.normalized, function (v, k) {
            destination.normalized = destination.normalized || {};
            destination.normalized[k] = mergeMetrics(destination.normalized[k], v);
        });

        return destination;
    }

    // Merges company data from two requests into a single object
    // Merge c into company (destination, source)
    CompareData.prototype.mergeCompanyData = function (company, c) {
        _.each(_.omit(c.periodSummary, 'dates'), function (sourcePresences, trendName) {

            if (!company.periodSummary[trendName]) {
                company.periodSummary[trendName] = [];
            }

            const existingPresences = company.periodSummary[trendName];

            _.each(sourcePresences, function (sourcePresence) {

                // skip sources with no presence id (this will skip metaTrends)
                // Q: we're skipping it now, but what does it mean to merge metaTrends?
                if (!_.get(sourcePresence, 'presence.id')) {
                    return;
                }

                const targetPresence = _.find(existingPresences, _.matchesProperty('presence.id', sourcePresence.presence.id));

                if (targetPresence) {
                    mergePresences(targetPresence, sourcePresence);
                } else {
                    existingPresences.push(sourcePresence);
                }
            });
        });
    };

    CompareData.prototype.processTrendData = function (c) {
        const me = this;
        const companyDisplay = RivalIQ.utils.companyDisplay;

        const company = me.companiesById[c.id];
        if (company) {
            me.mergeCompanyData(company, c);
            c = company;
        } else {
            me.companies.push(c);
            me.companiesById[c.id] = c;
        }

        // set has channel flags
        if (c.periodSummary.twitterTrends && c.periodSummary.twitterTrends[0] && c.periodSummary.twitterTrends[0].presence) {
            this.setHasChannel(CompareData.sources.TWITTER, c.id);
        }
        if (c.periodSummary.facebookTrends && c.periodSummary.facebookTrends[0] && c.periodSummary.facebookTrends[0].presence) {
            this.setHasChannel(CompareData.sources.FACEBOOK, c.id);
        }
        if (c.periodSummary.linkedInTrends && c.periodSummary.linkedInTrends[0]) {
            this.setHasChannel(CompareData.sources.LINKEDIN, c.id);
        }
        if (c.periodSummary.instagramInsightsTrends && c.periodSummary.instagramInsightsTrends[0]) {
            this.setHasChannel(CompareData.sources.INSTAGRAM_INSIGHTS, c.id);
        }
        // If we have Insights for this company that means we have a facebook presence
        if (c.periodSummary.facebookInsightsTrends && c.periodSummary.facebookInsightsTrends[0]) {
            this.setHasChannel(CompareData.sources.FACEBOOK, c.id);
        }
        if (c.periodSummary.youTubeTrends && c.periodSummary.youTubeTrends[0] && c.periodSummary.youTubeTrends[0].presence) {
            this.setHasChannel(CompareData.sources.YOUTUBE, c.id);
        }
        if (c.periodSummary.instagramTrends && c.periodSummary.instagramTrends[0] && c.periodSummary.instagramTrends[0].presence) {
            this.setHasChannel(CompareData.sources.INSTAGRAM, c.id);
        }
        if (c.periodSummary.tiktokTrends && c.periodSummary.tiktokTrends[0] && c.periodSummary.tiktokTrends[0].presence) {
            this.setHasChannel(CompareData.sources.TIKTOK, c.id);
        }
        if (c.periodSummary.urlExtractedDataTrends && c.periodSummary.urlExtractedDataTrends[0] && c.periodSummary.urlExtractedDataTrends[0].presence) {
            this.setHasChannel(CompareData.sources.WEB, c.id);
        }
        if (c.periodSummary.metaTrends) {
            this.setHasChannel(CompareData.sources.RIVALIQ, c.id);
        }

        // icon
        const iconUrl = companyDisplay.getIcon(c);
        if (iconUrl) {
            this.addIconUrl(c.id, iconUrl);
        }
    };


    CompareData.prototype.getMetaKeywords = function (metaKeywords) {
        return metaKeywords.replace(/\s*,\s*/g, ', ');
    };

    CompareData.prototype.sorterNumericDesc = function (a, b) {
        if (a.value && !b.value) {
            return -1;
        } else if (!a.value && b.value) {
            return 1;
        }
        const valA = parseFloat(a.value);
        const valB = parseFloat(b.value);

        if (valA < valB) {
            return 1;
        } else {
            return -1;
        }
    };

    CompareData.prototype.sorterCompanyName = function (a, b) {
        return a.name.localeCompare(b.gname);
    };

    // NOTE export the results, for both server and client
    if (typeof window === 'undefined') {
        module.exports = CompareData;
    } else {
        RivalIQ.data.CompareData = CompareData;
    }

})();
